import Vue from 'vue'
import VueRouter from 'vue-router'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/index/index.vue'),
    meta: {
      keepAlive: true,
    },
  },
  {
    path: '/draw',
    name: 'draw',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/draw/index.vue'),
  },
  {
    path: '/mine',
    name: 'mine',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/mine/index.vue')
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/about/index.vue')
  },
  {
    path: '/vip',
    name: 'vip',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/vip/index.vue')
  },
  
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/privacy/index.vue')
  },
  {
    path: '/service',
    name: 'service',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/service/index.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/agreement/index.vue')
  },
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import(/* webpackChunkName: "home" */ '@/pages/feedback/index.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
        return savedPosition
    }else{
      return {
        x: 0,
        y: 0
      }
    }
  }
})

export default router
